//#region Imports

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

//#endregion

//#region Interceptor

function isAbsoluteUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}

export function baseUrl(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const url = isAbsoluteUrl(req.url) ? req.url : `${environment.apiUrl}${req.url}`;

  const newReq = req.clone({ url });

  return next(newReq);
}

//#endregion
